module.exports = __webpack_public_path__ + "static/stamp-sidemenu.fc572fbf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/stamp-sidemenu.png
// module id = 564
// module chunks = 168707334958949